// @flow
import React from "react";
import imageDark from "../../static/images/trustpilot-dark.svg";
import imageLight from "../../static/images/trustpilot-light.svg";

type Props = {
  className?: string | null,
  isLight?: boolean
};

const TrustPilotLogo = ({ className = null, isLight }: Props) => (
  <img
    src={isLight ? imageLight : imageDark}
    alt="Trustpilot"
    width="126"
    height="31"
    className={className}
  />
);

TrustPilotLogo.defaultProps = {
  isLight: false
};

export default TrustPilotLogo;
